import AbstractDropdownButton from './abstract_dropdown_button'
import Ext from 'Ext'
import {escapeHtmlSymbols} from '../atUtils'

/**
 * A button with dropdown menu, based on the Ext.Button.
 * You may apply it to a standard HTML SELECT element, and it will be automatically converted to a button with dropdown
 * menu and hidden input. Option in SELECT with value '---' will convert to a separator.
 *
 * Events:
 *  change - fired when the selection is changed.
 *
 * Methods:
 *  getValue - get the currently selected value (the value that is to be sent to the server, NOT the visible text!)
 *  getItemByValue - returns the Ext.menu.Item with the specified value.
 *
 * CSS classes that will be automatically applied:
 *  at-dropdown-list-btn - the button's element
 *  at-dropdown-list-btn-ct - the button's container
 *  at-dropdown-list-btn-menu - the menu's element
 *
 * Required files:
 *  ExtJS library
 *  util.js
 *  /js/controls/abstract-dropdown-button.js
 */
const DropdownListButton = Ext.extend(AbstractDropdownButton, {

    defaultValue: null,
    firstMenuShow: true,
    menuCls: "",
    changeEventAllowed: true,

    initComponent: function() {
        var thisButton = this;

        var onCheckChange = function(item, checked) {
            if (checked) {
                thisButton.currentValue = item.value;
                thisButton.setText(item.text);
                thisButton.inputElement.value = item.value;
                if (thisButton.changeEventAllowed)
                    thisButton.fireEvent('change', this);
            }
        };

        this.addEvents('change');

        var selectElement = Ext.get(this.applyTo);
        var options = selectElement.dom.options;

        var menuItems = [];

        for (var i = 0; i < options.length; i++) {
            var option = options[i];

            if (option.value == '---') {
                menuItems.push('-'); // separator
            }
            else {
                var item = {
                    text: escapeHtmlSymbols(option.text),
                    value: option.value,
                    group: selectElement.id,
                    checked: option.selected,
                    id: option.id,
                    hideDelay: 150,
                    listeners:
                        {
                            checkchange: onCheckChange
                        }
                };

                menuItems.push(item);
            }

            if (option.selected) {
                this.setText(item.text);
                this.currentValue = item.value;
            }
        }

        this.menu = new Ext.menu.Menu({
            items: menuItems,
            cls: "at-dropdown-list-btn-menu " + this.menuCls
        });

        this.cls = "at-dropdown-list-btn " + (this.cls ? this.cls : "");
        this.ctCls = "at-dropdown-list-btn-ct " + (this.ctCls ? this.ctCls : "");

        this.inputElement = selectElement.insertHtml('afterEnd',
            '<input type="hidden" id="' + selectElement.id +
            '" name="' + selectElement.dom.name +
            '" value="' + this.currentValue + '">');
        selectElement.remove();
        DropdownListButton.superclass.initComponent.call(this);
    },

    getValue: function() {
        return this.currentValue;
    },

    getItemByValue: function(value) {
        return this.menu.items.find(
            function(item) { return item.value === value; });
    },

    template: new Ext.Template(
        '<table border="0" cellpadding="0" cellspacing="0" class="x-btn-wrap"><tbody><tr>',
        '<td class="x-btn-left"><i>&#160;</i></td><td class="x-btn-center"><em unselectable="on"><a href="javascript:void(0)" class="x-btn-text" type="{1}">{0}</a></em></td><td class="x-btn-right"><i>&#160;</i></td>',
        "</tr></tbody></table>"),

    buttonSelector: "a:first-child",

    onMenuHide: function(menu) {
        this.focus();
        DropdownListButton.superclass.onMenuHide.call(this, menu);
    },

    onMenuShow: function(menu) {
        this.menu.autoWidth();
        DropdownListButton.superclass.onMenuShow.call(this, menu);
        if (this.firstMenuShow) {
            this.adjustMenuItemIds(menu);
            this.firstMenuShow = false;
        }
    },

    adjustMenuItemIds: function(menu) {
        menu.items.each(function(item) {
            item.el.dom.id = item.id;
        });
    },

    setActiveItemByValue: function(value, suppressChangeEvent) {
        this.changeEventAllowed = !suppressChangeEvent;

        var menuItems = this.menu.items.items;
        var setActiveFlag;
        for (var i = 0; i < menuItems.length; i++) {
            setActiveFlag = (menuItems[i].value == value);
            menuItems[i].setChecked(setActiveFlag);
        }

        this.changeEventAllowed = true;
    },

    setActiveItemByPosition: function(position) {
        var menuItems = this.menu.items.items;
        var setActiveFlag;
        for (var i = 0; i < menuItems.length; i++) {
            setActiveFlag = (i === position);
            menuItems[i].setChecked(setActiveFlag);
        }
    },

    getDefaultValue: function() {
        return this.defaultValue;
    },

    setDefaultValue: function(value) {
        this.defaultValue = value;
    }

});
// register xtype
Ext.reg('at_dropdown_list_button', DropdownListButton);

export default DropdownListButton



// WEBPACK FOOTER //
// ./web/js/controls/dropdown_list_button.js